__webpack_require__.p = "/visual-design/infographics/en-IT/just-transition/";